import s from './PriceGroup.module.sass'
import { Checkbox } from '@shared/ui/Form/Single/Checkbox'
import { Text } from '@shared/ui/Typography/Text'
import { calculateDiscountedPrice } from '@shared/types/promotion'

export type GroupOption = {
  id: string
  label: string
  price: number
  discount?: number
}

interface Props {
  sizes?: string
  multiselect?: boolean
  checked?: GroupOption[]
  disabled?: boolean
  showOriginalPrice?: boolean
  notice?: string
  allSelectableOptions: GroupOption[]
  onChange: (options: GroupOption[]) => void
}

// 1000000 -> 1 000 000
const formatPrice = (price: number) => price.toLocaleString('ru-RU')

const includes = (options: GroupOption[], option: GroupOption) => {
  return options.some((locOpt) => locOpt.id === option.id)
}

export const PriceGroup = ({
  multiselect,
  allSelectableOptions = [],
  checked = [],
  onChange,
  disabled,
  showOriginalPrice = false,
  sizes = 'ML M',
  notice,
}: Props) => {
  const handleFlagFlip = (option: GroupOption) => () => {
    const isChecked = includes(checked, option)
    const whenMultiselect = isChecked ? checked.filter((locOpt) => locOpt.id !== option.id) : [...checked, option]
    const whenSingle = isChecked ? [] : [option]
    const newOptions = multiselect ? whenMultiselect : whenSingle
    onChange && onChange(newOptions)
  }

  return (
    <div className={s.list}>
      {allSelectableOptions.map((option) => (
        <div className={s.row} key={option.id}>
          <Checkbox
            mode={'checkbox'}
            option={{
              id: option.id,
              name: 'skip',
              disabled,
            }}
            checked={includes(checked, option)}
            onChange={handleFlagFlip(option)}
          />

          <Text sizes={sizes} className={s.content} onClick={handleFlagFlip(option)}>
            {option.label}

            <span>
              {option.discount && showOriginalPrice && (
                <Text sizes='S' className={s['original-price']}>
                  {option.price.toLocaleString('ru-RU', { maximumFractionDigits: 0 })} ₽
                </Text>
              )}
              {option.discount && <span className={s.discount}>-{option.discount}%</span>}
              {formatPrice(calculateDiscountedPrice(option.price, option.discount))} ₽
            </span>
          </Text>
        </div>
      ))}
      {notice && (
        <Text sizes='S' className={s.notice}>
          {notice}
        </Text>
      )}
    </div>
  )
}
